import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useGradeStatusRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-grade-statuses",
    async () => {
      return await api.gradeStatuses();
    },
    { staleTime: Infinity }
  );

  return {
    cadreStatuses: data ?? [],
    cadreStatusesLoading: isFetching,
    refetchCadreStatusesRef: refetch,
  };
}
